import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Edit,
  EditProps,
  TitleProps,
  useTranslate,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  SaveButton,
  TextField,
  ListButton,
} from 'react-admin'
import { EngineMediaActionDto } from '../../../../core/dto/engine-media/engine-media-action.dto'

const validateEngineMediaActionEdit = (values: EngineMediaActionDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.mediaAction) {
    errors.mediaAction = 'ra.validation.required'
  }
  if (!values.name) {
    errors.name = 'ra.validation.required'
  }
  return errors
}

interface EngineMediaActionTitleProps extends TitleProps {
  record?: EngineMediaActionDto
}

const EditTitle = (data: EngineMediaActionTitleProps) => {
  const { record: action } = data
  const translate = useTranslate()
  return (
    <span>
      {translate('resources.engine-media-actions.titles.edit')}: {action?.id}.{' '}
      {action?.name}
    </span>
  )
}

const EditToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const EngineMediaActionEdit = (props: EditProps) => (
  <Edit {...props} hasShow={false} title={<EditTitle />}>
    <SimpleForm
      redirect="show"
      toolbar={<EditToolbar />}
      validate={validateEngineMediaActionEdit}
    >
      <TextField source="id" label="ID" />
      <TextInput source="mediaAction" isRequired />
      <TextInput source="name" isRequired />
    </SimpleForm>
  </Edit>
)
